<template>
  <v-flex>
    <v-layout row wrap>
      <v-layout wrap class="ml-2">
        <v-flex xs12 sm12 md12 lg12 xl12 :style="{ background: dashboardGradient }">
          <v-container class="pa-6 pl-12">
            <v-flex xs12 sm12 md12 lg12 xl12>
              <v-row no-gutters>
                <v-layout row wrap class="pb-2">
                  <inline-svg
                    class="mt-2"
                    :src="getNavigationIcon(accountType)"
                    width="50"
                    height="50"
                    aria-label="Navigation Icon"
                  ></inline-svg>
                  <font class="display-1 font-weight-thin white--text pt-4 pl-2" data-qa="lifetimeisatransferin-title">
                    {{ $t('lisaAccountDetails.title') }}
                  </font>
                </v-layout>
              </v-row>
              <v-row class="pl-4">
                <v-layout wrap>
                  <v-flex lg9 xl9>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md6 lg5 xl4 class="px-1">
                        <font class="subheading font-weight-medium white--text">
                          {{ $t("accountDetails.accountNumber") }}
                        </font>
                        <br>
                        <font class="text-h5 font-weight-bold white--text">
                          {{ accountNumber }}
                        </font>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-row>
            </v-flex>
          </v-container>
        </v-flex>
      </v-layout>
    </v-layout>

    <v-flex class="mx-1 pt-4">
      <v-flex>
        <v-card class="pa-6" width="900" elevation="0" data-qa="lifetimeisatransferin-card">
          <v-container class="pt-0">
            <v-form
              ref="form"
              v-model="isFormValid"
              :lazy-validation="false"
              data-qa="lifetimeisatransferin-form"
            >
              <v-layout row justify-space-between>
                <v-row class="mb-3" v-if="!enableReviewScreen">
                  <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6">
                    <v-text-field
                      v-model="transferIn.lisaManager"
                      :label="$t('lisaAccountDetails.lisaManager')"
                      :color="primaryColor"
                      :maxlength=11
                      :rules="[
                        rules.requiredRule, rules.isValidFormat
                      ]"
                      filled
                      class="transferFunds--custom-textfield"
                      data-qa="lifetimeisatransferin-lisa-manager"
                    >
                      <v-tooltip slot="append" top data-qa="lifetimeisatransferin-tooltip">
                        <template v-slot:activator="{ on }">
                          <span v-on="on">
                            <v-icon slot="activator" :color="primaryColor">
                              mdi-information-outline
                            </v-icon>
                          </span>
                        </template>
                        <span>
                          {{ $t('lisaAccountDetails.lisaManagerInfo') }}
                        </span>
                      </v-tooltip>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6">
                    <v-text-field
                      v-model="transferIn.lisaAccount"
                      :label="$t('lisaAccountDetails.lisaAccount')"
                      :color="primaryColor"
                      :maxlength=25
                      :rules="[
                        rules.requiredRule, rules.isValidAccountFormat
                      ]"
                      filled
                      class="transferFunds--custom-textfield"
                      data-qa="lifetimeisatransferin-lisa-account"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-4">
                    <v-text-field
                      v-model="transferIn.lisaCurrTaxSubscription"
                      :label="$t('lisaAccountDetails.lisaCurrTaxSubscription')"
                      :prefix="transferIn.lisaCurrTaxSubscription ? $formatter.currency.getCurrencySymbol(defaultCurrency) : ''"
                      type="number"
                      :color="primaryColor"
                      filled
                      dense
                      @input="restrictToTwoDecimal('lisaCurrTaxSubscription', $event)"
                      @keydown="$formatter.validateAmount($event)"
                      :class="[
                        'transferFunds--custom-textfield custom-amount'
                      ]"
                      data-qa="lifetimeisatransferin-curr-tax-subscription"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-4">
                    <v-text-field
                      v-model="transferIn.lisaPrevTaxSubscription"
                      :label="$t('lisaAccountDetails.lisaPrevTaxSubscription')"
                      :prefix="transferIn.lisaPrevTaxSubscription ? $formatter.currency.getCurrencySymbol(defaultCurrency) : ''"
                      type="number"
                      :color="primaryColor"
                      filled
                      dense
                      @input="restrictToTwoDecimal('lisaPrevTaxSubscription', $event)"
                      @keydown="$formatter.validateAmount($event)"
                      :class="[
                        'transferFunds--custom-textfield custom-amount'
                      ]"
                      data-qa="lifetimeisatransferin-prev-tax-subscription"
                    ></v-text-field>
                  </v-flex>
                </v-row>
              </v-layout>
              <v-layout v-if="enableReviewScreen">
                <v-row class="ml-2 mt-3 mb-3">
                  <DisplayDetails
                    :config="{
                      title: 'Review & Confirm Details',
                      dataList: summaryDetails,
                      translation: 'lisaAccountDetails',
                    }"
                    class="pl-5"
                  />
                </v-row>
              </v-layout>
              <v-row class="mt-3">
                <v-btn
                  @click="goBack()"
                  class="text-none py-4 ml-6 mb-4"
                  :color="primaryColor"
                  rounded
                  outlined
                  data-qa="lifetimeisatransferin-goback-btn"
                >
                  <v-icon left>mdi-arrow-left</v-icon>
                  {{ $t("lisaAccountDetails.back") }}
                </v-btn>
                <v-btn
                  @click="onProceed()"
                  :color="primaryColor"
                  :disabled="!isFormValid || (this.transferIn.lisaPrevTaxSubscription == 0 && transferIn.lisaCurrTaxSubscription == 0)"
                  rounded
                  class="text-capitalize font-weight-bold white--text py-4 mx-2"
                  data-qa="lifetimeisatransferin-proceed-btn"
                >
                  {{ enableReviewScreen ? $t("lisaAccountDetails.confirm") : $t("lisaAccountDetails.proceed") }}
                </v-btn>
              </v-row>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
      <OtpHandler
        v-if="shouldShowOtpScreen"
        @otp-cancelled="shouldShowOtpScreen = false"
        @otp-success="confirmTransferIn"
      />
      <Modal
        v-if="showSuccessDialog"
        :config="modalConfig.successDialog"
        @btn1Action="returnToDashboard"
        @btn2Action="viewAccountDetails"
        data-qa="lifetimeisatransferin-success-dialog"
      />
    </v-flex>
  </v-flex>
</template>

<script>
import preload from '@/util/preload'
import commonService from '@/service/commonService.js'
import DisplayDetails from '@/views/common/DisplayDetails.vue'
import '@/styles/pages/transferFunds.scss'

export default {
  name: 'LifetimeIsaTransferIn',
  components: {
    DisplayDetails,
    Modal: () => import('@/components/common/Modal.vue'),
    OtpHandler: () => import('@/components/common/OtpHandler.vue')
  },
  data () {
    return {
      rules: {
        requiredRule: (v) => Boolean(v) || 'Required Field',
        isValidFormat: (v) => /^Z([0-9]{4}|[0-9]{6})$/.test(v) || this.$t('lisaAccountDetails.errorMsg.invalidLisaManager'),
        isValidAccountFormat: (v) => /^[a-zA-Z0-9]+$/.test(v) || this.$t('errors.common.invalidFormat')
      },
      defaultCurrency: this.$appSettings.defaultConfigurations.currencyFormat.currency,
      isFormValid: false,
      accountNumber: '',
      accountType: '',
      summaryDetails: [],
      enableReviewScreen: false,
      transferIn: {
        lisaManager: '',
        lisaAccount: '',
        lisaCurrTaxSubscription: 0,
        lisaPrevTaxSubscription: 0
      },
      enableOTP: this.$appSettings.defaultConfigurations.enableOTPForLisaTransferIn,
      shouldShowOtpScreen: false,
      modalConfig: {
        successDialog: {
          enabled: false,
          persistent: true,
          title: this.$t('lisaAccountDetails.transferInSuccessTitle'),
          subtitle: this.$t('lisaAccountDetails.transferInSuccessMsg'),
          btn1Label: this.$t('lisaAccountDetails.gotoDashboardBtn'),
          btn2Label: this.$t('lisaAccountDetails.viewAccountDetailsBtn'),
          width: 600
        }
      },
      showSuccessDialog: false
    }
  },
  async created () {
    if (this.$route.params.accountType !== undefined && this.$route.params.accountNumber !== undefined) {
      this.accountType = this.$route.params.accountType
      this.accountNumber = this.$route.params.accountNumber
      this.balance = this.$route.params.balance
      this.currency = this.$route.params.currency
      this.depositAmt = this.$route.params.depositAmt
    } else {
      this.$router.push('/home')
    }
    await this.getAccountDetails(this.accountNumber)
  },
  methods: {
    goBack () {
      if (this.enableReviewScreen) {
        this.enableReviewScreen = false
        this.summaryDetails = []
      } else {
        this.viewAccountDetails()
      }
    },
    viewAccountDetails () {
      this.$router.push({
        name: 'AccountDetails',
        params: {
          product: this.accountDetails,
          balance: this.balance,
          accountId: this.accountNumber,
          accountType: this.accountType,
          navToTab: 1
        }
      }).catch(() => {})
    },
    onProceed () {
      if (!this.enableReviewScreen) {
        const formatCcy = (amount) => this.$formatter.currency.customFormatter(amount, this.defaultCurrency)

        this.summaryDetails.push(
          {
            label: 'lisaManager',
            value: this.transferIn.lisaManager
          },
          {
            label: 'lisaAccount',
            value: this.transferIn.lisaAccount
          },
          {
            label: 'lisaCurrTaxSubscription',
            value: formatCcy(this.transferIn.lisaCurrTaxSubscription)
          },
          {
            label: 'lisaPrevTaxSubscription',
            value: formatCcy(this.transferIn.lisaPrevTaxSubscription)
          }
        )
        this.enableReviewScreen = true
      } else {
        if (this.enableOTP) {
          this.shouldShowOtpScreen = true
          return
        }
        this.confirmTransferIn()
      }
    },
    async getAccountDetails (accountNumber) {
      const response = accountNumber ? await commonService.getAccountDetails(accountNumber) : ''
      if (response && !response.causes) {
        this.accountDetails = response
        this.accountNumber = this.accountDetails.accountId
      }
    },
    async confirmTransferIn () {
      this.shouldShowOtpScreen = false
      const data = {
        accountId: this.accountNumber,
        previoustaxyearAmount: this.transferIn.lisaPrevTaxSubscription[0] || 0,
        currenttaxyearAmount: this.transferIn.lisaCurrTaxSubscription[0] || 0,
        existingLISAno: this.transferIn.lisaAccount,
        lisamanagerRefno: this.transferIn.lisaManager
      }
      const response = await commonService.createLisaTransferIn(data)
      if (!response.causes) {
        this.showSuccessDialog = true
        this.modalConfig.successDialog.enabled = true
      }
    },
    async returnToDashboard () {
      await preload.getListOfAccounts(
        JSON.parse(sessionStorage.getItem('username'))
      )
      this.$router.push('/home')
    },
    getNavigationIcon (accType) {
      let returnType
      switch (accType) {
        case 'SVGS':
          returnType = this.getSvgIconSrc('Savings_1')
          break
        default:
          returnType = this.getSvgIconSrc('Savings_1')
          break
      }
      return returnType
    },
    restrictToTwoDecimal (field, value) {
      if (value?.length) {
        this.transferIn[field] = value.match(/^\d+\.?\d{0,2}/)
      }
    }
  }
}
</script>
